import { distinctUntilChanged } from "rxjs/operators";
import { equals } from "ramda";
import { min, max, prop, reduce, path, map, compose, curry } from "ramda";


export const ASYNC_STATE = {
  INITIAL: "INITIAL",
  LOADING: "LOADING",
  LOADED: "LOADED",
  ERROR: "ERROR"
};

export const findIdFor = layer =>
  layer.definitionExpression ? parseInt(layer.definitionExpression.split("=")[1], 10) : null;

export const getPropIds = ({ collections, field, value }) => {
  return flatten(
    collections.features
      .filter(feature => feature[field] === value)
      .map(feature => feature.layerIds)
  );
};

export const getProps = curry((paths, propName, item) =>
  compose(
    map(prop(propName)),
    path(paths)
  )(item));

export const distinctUntilArrayChanged = () =>
  distinctUntilChanged((x, y) => equals(x, y));

export const updateUI = (ui) => state => ({
  ui: {
    ...state.ui,
    ...ui
  }
});
